<template>
  <div v-if="isFlatTotalAnnualMaxFeeAmount">
    {{ formatNumber(annualMaxFeeTotal, 'shortDecimal') }}
  </div>
  <ViewLinkRender v-else-if="isHistoricTotalAnnualMaxFee">
    <template #modal-content="{ closeModal }">
      <AnnualFeeTotalDisplay
        :mwc-id="mwcId"
        :name="totalAnnualFeeName"
        :schedule="totalFeeSchedule"
        is-annual-max-fee-total
        @close="closeModal"
      />
    </template>
  </ViewLinkRender>
  <div v-else>
    &mdash;
  </div>
</template>

<script>
import AnnualFeeTotalDisplay from 'hypo-fee-schedule-summary-list/src/fees/historic-max-fee/AnnualFeeTotalDisplay';
import ViewLinkRender from './ViewLinkRender';
import ManagerFeeHelperMixin from './mixins/manager-fee-helper-mixin';
import TotalFeeHelperMixin from './mixins/total-fee-helper-mixin';
import { addFloatNumber, isMaxFee, isFlatOrHistoricMaxFee } from '../../../utils/utils';

export default {
  name: 'annual-max-fee-total-render',
  components: {
    ViewLinkRender,
    AnnualFeeTotalDisplay,
  },
  mixins: [ManagerFeeHelperMixin, TotalFeeHelperMixin],
  props: {
    mwcId: String,
    feeName: String,
    securityType: String,
    schedule: Object,
  },
  inject: ['formatNumber'],
  computed: {
    annualMaxFeeTotal() {
      if (this.isFlatTotalAnnualMaxFee) {
        // flat max fee, flat manager fee.
        const { maxFee } = this.schedule;
        return addFloatNumber([maxFee, this.getManagerFee(this.managerFee, this.schedule)]);
      }
      return this.totalFeeSchedule?.feeScheduleDetails?.[0]?.totalAnnualMaxFee;
    },
    isFlatTotalAnnualMaxFee() {
      return isMaxFee(this.schedule) && !this.isHistoricManagerFee;
    },
    isHistoricTotalAnnualMaxFee() {
      const feeScheduleDetails = this.totalFeeScheduleDetails;
      return (
        isFlatOrHistoricMaxFee(this.schedule) &&
        Array.isArray(feeScheduleDetails) &&
        feeScheduleDetails.length > 1 &&
        feeScheduleDetails.some(
          timeSchedule =>
            timeSchedule?.totalAnnualMaxFee !== feeScheduleDetails?.[0]?.totalAnnualMaxFee
        )
      );
    },
    isFlatTotalAnnualMaxFeeAmount() {
      return (
        isFlatOrHistoricMaxFee(this.schedule) &&
        (this.isFlatTotalAnnualMaxFee || !this.isHistoricTotalAnnualMaxFee)
      );
    },
  },
};
</script>
